import "./profile.css";
import profile from "../../assets/svgs/icon-profile.svg";
import ModalProfile from "../modalProfile/ModalProfile";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUser } from "../../redux/actions/user";

function Profile() {
  const [showProfile, setShowProfile] = useState(false);
  const dispatch = useDispatch();
  const handleProfileClick = () => {
    setShowProfile(!showProfile);
  };

  const handleCloseModal = () => {
    setShowProfile(false);
  };

  const { basicUserInfo } = useSelector((state: any) => state.user);

  useEffect(() => {
    dispatch(getUser());
  }, []);

  return (
    <div className="containerModalProfile">
      <div
        data-testid="profile-mock"
        className="containerModalProfile"
        onClick={handleProfileClick}
        role="button"
      >
        <img className="iconUser" src={profile} alt="icon profile" />
        <span className="nameProfile">{basicUserInfo?.name}</span>
      </div>
      {showProfile && (
        <ModalProfile
          options={{
            nome: basicUserInfo?.name,
            email: basicUserInfo?.email,
          }}
          onClose={handleCloseModal}
        />
      )}
    </div>
  );
}
export default Profile;
